import { Eye } from "lucide-react";
import { Button } from "@marekl/adminer/components";
import { notifyError } from "@marekl/adminer/api";
import { useStopImpersonation } from "../../auth/queries";
import type { User } from "../../auth/queries";
import styles from "./ImpersonationBanner.module.css";

interface Props {
  user: User;
}

export function ImpersonationBanner({ user }: Props) {
  const stop = useStopImpersonation();

  async function handleStop() {
    try {
      await stop.mutateAsync();
    } catch (err) {
      notifyError(err);
    }
  }

  return (
    <div
      className={styles.banner}
      role="status"
      aria-live="polite"
      data-testid="impersonation-banner"
    >
      <Eye size={14} aria-hidden="true" />
      <span className={styles.text}>
        Vystupujete za{" "}
        <span className={styles.name}>{user.display_name || user.email}</span>
      </span>
      <Button
        variant="primary"
        onClick={handleStop}
        loading={stop.isPending}
      >
        Ukončit vystupování
      </Button>
    </div>
  );
}
